
import { GridDataService } from './grid-data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';
import { sortBy } from 'lodash';
import { HelperUtils } from '../../utility/helper-utils';
import { IntlService } from '@progress/kendo-angular-intl';

@Injectable()
export class CommunityProviderProgramSearchListService extends GridDataService
{
    constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService, public intl: IntlService)
    {
        super(http, '/public/community/provider/search', translate, messageHandlerService);
    }

    public setCommunityServicesFields(p: any): void
    {
        const now = new Date();
        const nowString = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;

        // Sorting opening times to display
        if (p.openingTimes !== null)
        {
            const times = p.openingTimes;
            times.forEach(data =>
            {
                data.fromDate = new Date(`${nowString} ${data.from}`);
                data.toDate = new Date(`${nowString} ${data.to}`);
                data.sort = HelperUtils.daysConst().indexOf(data.day);
                data.day = data.day ? data.day.charAt(0).toUpperCase() + data.day.substring(1).toLowerCase() : '';
            });
            p.openingTimes = sortBy(times, ['sort']);
        }
        p.formattedAddress = p.address !== null ? HelperUtils.formatAddress(p.address) : '';
        p.serviceTypeName = p.serviceCategory != null && p.serviceCategory.serviceType != null ? p.serviceCategory.serviceType.displayName : '';
        p.serviceCategoryName = p.serviceCategory != null ? p.serviceCategory.name : '';
        p.languagesName = p.languages !== null ? p.languages.map(x => x.displayName).join(', ') : '';
        p.enhancedServicesName = p.enhancedServices !== null ? p.enhancedServices.map(x => x.displayName).join(', ') : '';
        p.taxonomiesName = p.taxonomies !== null ? p.taxonomies.map(x => x.displayName).join(', ') : '';
        p.resourceStatusName = p.resourceStatus !== null ? p.resourceStatus.displayName : '';
        p.lastModifiedOn = this.intl.formatDate(new Date(p.lastModifiedOn), 'g');

        // Set displayName using description and code
        if (p.providerTaxonomies)
        {
            p.providerTaxonomies.forEach(d => { d.displayName = `${d.displayName} (${d.code})`; });
        }
    }
}
